import { useSearchParams } from 'react-router';

export function useListFilters() {
    const [searchParams, setSearchParams] = useSearchParams();

    const filters = {
        search: searchParams.get('search') || '',
        sort: searchParams.get('sort') || 'name',
        direction: searchParams.get('direction') || 'asc',
        page: Number(searchParams.get('page')) || 1,
        status: searchParams.get('status') || '',
        type: searchParams.get('type') || '',
        domain: searchParams.get('domain') || '',
        tags: searchParams.get('tags') || '',
        is_system: searchParams.get('is_system') || '',
    };

    const setFilter = (key: string, value: string) => {
        setSearchParams((prev) => {
            if (value) prev.set(key, value);
            else prev.delete(key);
            if (key !== 'page') prev.delete('page');
            return prev;
        });
    };

    const activeFilters = Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== '' && v !== 0),
    );

    return { filters, activeFilters, setFilter };
}
